import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { EmployeesListService } from "../employees-list.service";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { EMPLOYEES_ROUTES } from "../const";
import { FicherosEmpleadosService } from "../../../services/employees/ficheros-empleados.service";
import { Observable } from "rxjs";
import { EmployeesFilesDTO } from "../../../models/personal/ficheros.model";
import { EmployeesListModel } from "../employees-list.model";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { GastosFormComponent } from "./gastos-form.component";
import { consts } from "../../../consts";
import { Utils } from "../../../shared/utils";
import { DialogsService } from "../../../shared/components/dialogs/dialogs.service";
import { RechazarVacacionesComponent } from "../vacaciones/vacaciones-form.component";

@Component({
    selector: "app-gastos-empleado",
    templateUrl: "./gastos.component.html",
    styleUrls: ["./gastos.component.css"],
    standalone: false
})
export class GastosComponent implements OnInit {

  // #region Propiedades del componente
  displayedColumnsWithEmployee: string[] = ['empleado', 'relacion.cadenaFecha', 'relacion.nombreArchivo', 'fichero.type', 'relacion.tipoGasto', 'fichero.path', 'relacion.aprobado', 'relacion.totalImporte', 'acciones'];
  displayedColumns: string[] = ['relacion.cadenaFecha', 'relacion.nombreArchivo', 'fichero.type', 'relacion.tipoGasto', 'fichero.path', 'relacion.aprobado', 'relacion.totalImporte', 'acciones'];
  empleados: EmployeesListModel[] = [];
  formBusqueda: UntypedFormGroup = null;
  idEmpleadoSeleccionado: number = null;
  listaFicherosEmpleadosDTO$: Observable<EmployeesFilesDTO[]> = this.ficherosEmpleadosService.listaFicherosEmpleadosDTO$;
  routes: object[] = [];
  row: EmployeesFilesDTO;
  // #endregion

  constructor(
    private router: Router,
    public dialog: MatDialog,
    public dialogsService: DialogsService,
    public EmployeesListService: EmployeesListService,
    public ficherosEmpleadosService: FicherosEmpleadosService,
    protected snackBar: MatSnackBar
  ) {
    this.routes = EMPLOYEES_ROUTES;
  }

  // #region Métodos del componente

  cancelar(): void {
    if (this.formBusqueda != null) {
      this.formBusqueda.reset();
    }
    this.idEmpleadoSeleccionado = null;

    this.ficherosEmpleadosService.resetearImporteValidadoPorEmpleado();
  }

  create(): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    this.dialog.open(GastosFormComponent, {
      width: '90%',
      maxWidth: '900px',
      maxHeight: '90vh',
      data: {},
    });
  }

  descargar(): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    if (this.row !== null) {
      this.ficherosEmpleadosService.viewDocument(this.row);
    }
  }

  eliminar(): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    if (this.row !== null) {
      // Se comprueba que la ruta (path) del fichero TENGA el valor 'files/Facturas sin contabilizar/'
      if (this.row.fichero.path.includes('files/Facturas sin contabilizar')) {
        this.ficherosEmpleadosService.deleteFicheroEmpleado(this.row.relacion.employeesId, this.row.relacion.id).subscribe((resultado) => {
          (resultado: boolean) => {
            if (resultado) {
              this.snackBar.open('Fichero eliminado correctamente', 'Cerrar', {
                duration: 5000,
                horizontalPosition: 'center',
                verticalPosition: 'bottom',
              });

              this.ficherosEmpleadosService.getListFicherosEmpleadosDTO();
            }
          }
        });
      } else {
        this.snackBar.open('No se puede eliminar el fichero porque ya se han procesado sus gastos', 'Cerrar', {
          duration: 5000,
          horizontalPosition: 'center',
          verticalPosition: 'bottom',
        });
      }
    } else {
      // Mostrar un mensaje indicando que no se ha seleccionado ninguna fila
      this.snackBar.open('No se ha seleccionado ninguna fila', 'Cerrar', {
        duration: 5000,
        horizontalPosition: 'center',
        verticalPosition: 'bottom',
      });
    }
  }

  /**
   * Rechaza un fichero de empleado.
   */
  rechazar(): void {
    if (this.row !== null) {
      this.dialog.open(RechazarVacacionesComponent, {
        data: {
          title: "¿Seguro que quiere RECHAZAR el gasto asociado con el empleado? Debe indicar el motivo del rechazo.",
        }
      })
        .afterClosed().subscribe((result: string) => {
          if (result.length > 0) {
            this.ficherosEmpleadosService.rechazarFicheroEmpleado(this.row.relacion.id, result)
              .subscribe({
                next: (resultado: boolean) => { }
              })
          }
        });
    }
  }

  /**
   * Valida un fichero de empleado.
   */
  validar(): void {
    if (this.row !== null) {

      this.dialogsService.confirm('¿Confirmar validación?', '¿Está seguro que desea validar este gasto?').subscribe((result) => {
        if (result) {
          this.ficherosEmpleadosService.validarFicheroEmpleado(this.row.relacion.id)
            .subscribe({
              next: (resultado: boolean) => {
                if (resultado) {
                  // Actualizar los datos de la fila para indicar que se ha validado
                  this.row.relacion.aprobado = true;
                }
              }
            })
        }
      });
    }
  }

  ngOnInit() {
    // Carga de la lista de ficheros de empleados para el usuario actual (solamente los no rechazados)
    this.ficherosEmpleadosService.getListFicherosEmpleadosDTO(true);

    // Obtención de los empleados ...
    this.EmployeesListService.getList().then((data) => {
      this.empleados = data;
      this.inicializarFormulario();
    });
  }

  nombreEmpleado(idEmpleado: number): string {
    const empleado = this.empleados.find((e) => e.uid === idEmpleado);
    return empleado ? empleado.name : '';
  }

  obtenerFicherosPorEmpleado(): void {
    if (!Utils.IsTierFour()) {
      this.snackBar.open(consts.UPDATE_SUBSCRIPTION_TIER_MESSAGE, null, {
        duration: 3000,
      });
      return;
    }

    if (this.formBusqueda.valid) {
      this.idEmpleadoSeleccionado = this.formBusqueda.get('empleado').value;

      this.ficherosEmpleadosService.getListFicherosEmpleadosDTOByEmployee(this.idEmpleadoSeleccionado);
    }
  }

  setRow(row: EmployeesFilesDTO): void {
    this.row = row;
  }

  // #endregion

  // #region Métodos privados

  /**
   * Inicializa el formulario de búsqueda.
   */
  private inicializarFormulario(): void {
    this.formBusqueda = new UntypedFormGroup({
      empleado: new UntypedFormControl(null, [Validators.required])
    });
  }

  // #endregion
  public trackByIndex(i: number) { return i; }

}
